import React from 'react';
import PropTypes from 'prop-types';
import { SvgPathAttributes } from './star.constants';
import styles from './star.module.scss';

function Star({ value }) {
  let type;
  let { dAttributePath, dAttributeToLink } = SvgPathAttributes.empty;

  if (value < 0.25) {
    type = 'empty';
  } else if (value < 0.5) {
    type = 'quarter';
    dAttributeToLink = SvgPathAttributes.quarter.dAttributeToLink;
    dAttributePath = SvgPathAttributes.quarter.dAttributePath;
  } else if (value < 0.75) {
    type = 'half';
    dAttributePath = SvgPathAttributes.half.dAttributePath;
  } else if (value < 1) {
    type = '3quarter';
    dAttributePath = SvgPathAttributes.threeQuarter.dAttributePath;
  } else if (value === 1) {
    type = 'full';
    dAttributePath = SvgPathAttributes.full.dAttributePath;
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <defs>
        <clipPath id={`clip-path-${type}`}>
          <path className={styles.starCliPath} d={dAttributeToLink} />
        </clipPath>
      </defs>
      <g>
        <path
          className={styles.starPath}
          d={SvgPathAttributes.starPathDAttribute}
        />
        <g className={styles[`starG-${type}`]}>
          <path className={styles.starPath} d={dAttributePath} />
        </g>
      </g>
    </svg>
  );
}

Star.propTypes = {
  /** Value `required` between 0 and 1. */
  value: PropTypes.number.isRequired,
};

export default Star;
